import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



  const cardData =
  {
    keyword: 'Best Cab Service in Pune',
    heading: 'Sai Trupti Cabs: Best Cab Service in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable cab services in Pune, designed to make your local and outstation travel smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors, comfortable seating, and ample luggage space. Every trip is handled by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your journey. With transparent pricing, flexible booking options (local, one-way, or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel in Pune convenient, affordable, and worry-free, delivering the best cab service experience for every passenger.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Best Cab Service in Pune",
    "description": "Experience the best cab service in Pune with clean, comfortable vehicles and professional drivers. Offering 24x7 availability, AC/non-AC options, on-time pickups, and transparent fares for local, airport, and outstation travel. Perfect for daily commutes, business trips, and family outings with flexible booking and real-time tracking."
  },
  {
    "name": "Top Taxi Service Pune",
    "description": "Book from the top-rated taxi service in Pune providing a wide range of vehicles including sedans, SUVs, and luxury cabs. Enjoy punctual service, courteous drivers, flexible pickup/drop options, and competitive fares for both one-way and round-trip travel within and outside the city."
  },
  {
    "name": "Pune Cab Booking",
    "description": "Convenient and fast online cab booking in Pune with multiple options—AC/non-AC, one-way, round-trip, or outstation. Get instant confirmation, professional chauffeurs, transparent fares, and 24-hour customer support for a smooth and comfortable travel experience."
  },
  {
    "name": "Pune AC Cabs",
    "description": "Enjoy cool and comfortable rides with AC cabs in Pune. Ideal for local city tours, office commutes, and long drives with professional drivers, well-maintained vehicles, flexible pickup/drop points, and affordable fares designed for ultimate comfort."
  },
  {
    "name": "Non AC Cabs Pune",
    "description": "Hire budget-friendly non-AC cabs in Pune for economical and reliable travel. Equipped with skilled drivers, clean vehicles, flexible routes, and transparent pricing, this service is perfect for short-distance and regular city travel."
  },
  {
    "name": "Luxury Cabs Pune",
    "description": "Travel in style with premium luxury cabs in Pune featuring high-end sedans, SUVs, and executive vehicles. Ideal for weddings, VIP events, and corporate travel, with professional chauffeurs, AC comfort, and superior interiors ensuring a first-class experience."
  },
  {
    "name": "Pune Outstation Cab Service",
    "description": "Book reliable outstation cabs from Pune for weekend getaways or long-distance travel. Choose from AC/non-AC cars with professional drivers, flexible schedules, affordable packages, and comfortable seating for family, business, or group trips."
  },
  {
    "name": "Pune One Way Cab",
    "description": "Book one-way cabs from Pune to destinations like Mumbai, Nashik, Shirdi, and more. Enjoy clean vehicles, skilled drivers, transparent one-way fares, and flexible pickup timings, making your travel affordable and hassle-free."
  },
  {
    "name": "Pune Airport Cabs",
    "description": "Reliable Pune airport cab service with on-time pickups and drops to Pune Airport and Mumbai Airport. Choose from sedans, SUVs, and luxury cabs with AC/non-AC options, professional chauffeurs, and 24x7 booking support for stress-free airport transfers."
  },
  {
    "name": "Affordable Cab Service Pune",
    "description": "Pocket-friendly cab service in Pune offering transparent pricing, well-maintained vehicles, and courteous drivers. Perfect for local sightseeing, corporate trips, and airport transfers with flexible booking options and guaranteed comfort."
  },
  {
    "name": "Corporate Cab Pune",
    "description": "Professional corporate cab service in Pune designed for business meetings, conferences, and employee travel. Offering executive sedans and SUVs, AC/non-AC options, trained chauffeurs, flexible billing, and real-time tracking for seamless corporate mobility."
  },
  {
    "name": "Wedding Cab Pune",
    "description": "Book stylish and elegant wedding cabs in Pune for guests and family members. Choose from luxury sedans, SUVs, or decorated vehicles with experienced drivers, punctual service, and comfortable seating to make wedding transportation smooth and memorable."
  },
  {
    "name": "Pune Ertiga Cab Hire",
    "description": "Hire Ertiga cabs in Pune for local and outstation trips with spacious seating for 6+1 passengers. Offering AC/non-AC options, skilled drivers, luggage support, flexible pickup/drop points, and transparent fares for family and group travel."
  },
  {
    "name": "Pune Innova Crysta Hire",
    "description": "Premium Innova Crysta hire in Pune for business trips, family outings, and long-distance travel. Enjoy AC comfort, professional chauffeurs, luggage support, online booking, and affordable pricing with flexible pickup and drop facilities."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Book your cab online in Pune with instant confirmation and secure payment options. Choose from AC/non-AC sedans, SUVs, and luxury vehicles with professional drivers, flexible pickup schedules, and transparent fares available 24x7."
  }
],
"tableData": [
  ["Best Cab Service in Pune", "Top Taxi Service Pune"],
  ["Pune Cab Booking", "Pune AC Cabs"],
  ["Non AC Cabs Pune", "Luxury Cabs Pune"],
  ["Pune Outstation Cab Service", "Pune One Way Cab"],
  ["Pune Airport Cabs", "Affordable Cab Service Pune"],
  ["Corporate Cab Pune", "Wedding Cab Pune"],
  ["Pune Ertiga Cab Hire", "Pune Innova Crysta Hire"],
  ["Online Cab Booking Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Best Cab Service in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  offers top-rated cab services across Pune — ideal for local rides, airport transfers, outstation trips, and one-way or round trips."
  },
  {
    "WhyChooseheading": "Reliable & Punctual Drivers",
    "WhyChoosedescription": "Our professional drivers are trained, verified, and familiar with Pune routes, ensuring timely pickups, safe journeys, and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear and affordable fares with no hidden charges. Our pricing is designed to provide value for both short city rides and long-distance journeys."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, luxury cars, or tempo travellers to match your group size, luggage requirements, and travel preferences."
  },
  {
    "WhyChooseheading": "Online & Easy Booking",
    "WhyChoosedescription": "Book your cab through our website, WhatsApp, or call — receive instant confirmation and choose your pickup and drop locations with ease."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer pickups and drops anywhere in Pune, including city, airport, railway station, hotels, and suburban locations."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and maintained to provide comfort and reliability for every ride."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, changes, cancellations, and queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Payment & Cancellation",
    "WhyChoosedescription": "We provide multiple payment options (online, UPI, card, or cash) and flexible cancellation/modification policies for convenience and peace of mind."
  }
]



















  }

const faqData = [
  {
    question: 'Is Sai Trupti Cabs  the best cab service in Pune?',
    answer: 'Yes, Sai Trupti Cabs  is recognized as one of the best cab services in Pune, offering reliable, affordable, and comfortable travel for local, outstation, and airport transfer needs.',
  },
  {
    question: 'What makes Sai Trupti Cabs one of the best cab services in Pune?',
    answer: 'Sai Trupti Cabs stands out for its punctual service, professional drivers, clean and well-maintained vehicles, transparent pricing, and 24×7 customer support—ensuring complete satisfaction for every ride.',
  },
  {
    question: 'How can I book a cab in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24×7 customer support team. Choose your pickup location, preferred cab type, and complete your booking securely online.',
  },
  {
    question: 'What types of cabs are available with Sai Trupti Cabs in Pune?',
    answer: 'We offer a wide fleet of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and luxury cars to meet all travel needs and budgets in Pune.',
  },
  {
    question: 'Are the drivers professional and trained at Sai Trupti Cabs?',
    answer: 'Yes, all our drivers are experienced, polite, and trained in city as well as highway driving. They ensure a smooth, safe, and enjoyable journey for every passenger.',
  },
  {
    question: 'Does Sai Trupti Cabs provide airport transfer services in Pune?',
    answer: 'Certainly. We provide efficient airport pickup and drop services to and from Pune Airport as well as Mumbai Airport, ensuring timely travel for your flights.',
  },
  {
    question: 'Is the Sai Trupti Cabs service available 24×7 in Pune?',
    answer: 'Yes, our cab services in Pune operate round the clock, so you can book a ride anytime, whether it’s an early morning airport trip or a late-night return.',
  },
  {
    question: 'What are the Pune cab service fares offered by Sai Trupti Cabs?',
    answer: 'Our cab fares in Pune start from approximately ₹500–₹700 for local trips, and vary depending on vehicle type, duration, and distance. We maintain complete transparency—no hidden charges.',
  },
  {
    question: 'What payment methods are accepted for cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for your convenience and a seamless booking experience.',
  },
  {
    question: 'What safety and hygiene measures are followed by Sai Trupti Cabs in Pune?',
    answer: 'All vehicles are regularly sanitized, equipped with basic safety kits, and our drivers follow hygiene protocols to ensure a clean and safe travel experience for all passengers.',
  },
  {
    question: 'Is customer support available during my cab journey in Pune?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you before, during, and after your ride in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Sai Trupti Cabs truly offers the best cab service in Pune. My cab arrived on time, the car was spotless, and the driver was professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent service from Sai Trupti Cabs! Booking was smooth, the rates were reasonable, and the overall experience was fantastic.',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune",
  "image": "https://saitrupticabs.com/assets/images/pune-cab-service.jpg",
  "description": "Top cab service in Pune offering AC and Non-AC cabs, luxury cabs, outstation trips, airport transfers, corporate, and wedding cabs. Affordable and reliable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/best-cab-service-in-pune"
  }
};







  return (
    <div>
      <Helmet>
  <title>Best Cab Service in Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Top cab service in Pune offering AC and Non-AC cabs, luxury cabs, outstation trips, airport transfers, corporate, and wedding cabs. Affordable and reliable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Best Cab Service in Pune, Top Taxi Service Pune, Pune Cab Booking, Pune AC Cabs, Non AC Cabs Pune, Luxury Cabs Pune, Pune Outstation Cab Service, Pune One Way Cab, Pune Airport Cabs, Affordable Cab Service Pune, Corporate Cab Pune, Wedding Cab Pune, Pune Ertiga Cab Hire, Pune Innova Crysta Hire, Online Cab Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;